import { ORGANIZATION_GOVERNANCE_COMMAND_REGISTRY as BASE_ORGANIZATION_GOVERNANCE_COMMAND_REGISTRY, ORGANIZATION_GOVERNANCE_READ_RESOURCES as BASE_ORGANIZATION_GOVERNANCE_READ_RESOURCES, } from './organization-governance-command-registry.js';
const field = (key, kind = 'TEXT', required = true) => ({ key, kind, required });
export const FEE_RULE_GOVERNANCE_COMMANDS = Object.freeze([
    {
        commandId: 'fee-rules.create-version',
        area: 'ACCOUNTING',
        method: 'POST',
        path: '/api/fee-rules',
        required: [
            'jurisdiction',
            'ruleType',
            'effectiveFrom',
            'deductibleClassification',
            'components',
        ],
        optional: ['branchId', 'effectiveTo', 'roundingPolicy', 'sourceReference'],
        fields: [
            field('jurisdiction'),
            field('ruleType'),
            field('branchId', 'TEXT', false),
            field('effectiveFrom'),
            field('effectiveTo', 'TEXT', false),
            field('deductibleClassification'),
            field('roundingPolicy', 'TEXT', false),
            field('sourceReference', 'TEXT', false),
            field('components', 'STRUCTURED_LIST'),
        ],
    },
    {
        commandId: 'fee-rules.submit',
        area: 'ACCOUNTING',
        method: 'POST',
        path: '/api/fee-rules/:id/submit',
        pathParameterKeys: ['id'],
        required: ['version'],
        fields: [field('version', 'INTEGER')],
    },
    {
        commandId: 'fee-rules.approve',
        area: 'ACCOUNTING',
        method: 'POST',
        path: '/api/fee-rules/:id/approve',
        pathParameterKeys: ['id'],
        required: ['version'],
        fields: [field('version', 'INTEGER')],
    },
    {
        commandId: 'fee-rules.suspend',
        area: 'ACCOUNTING',
        method: 'POST',
        path: '/api/fee-rules/:id/suspend',
        pathParameterKeys: ['id'],
        required: ['version'],
        fields: [field('version', 'INTEGER')],
    },
    {
        commandId: 'fee-rules.retire',
        area: 'ACCOUNTING',
        method: 'POST',
        path: '/api/fee-rules/:id/retire',
        pathParameterKeys: ['id'],
        required: ['version'],
        fields: [field('version', 'INTEGER')],
    },
]);
export const FEE_RULE_GOVERNANCE_READ_RESOURCES = Object.freeze([
    { area: 'ACCOUNTING', path: '/api/fee-rules' },
]);
export const EFFECTIVE_ORGANIZATION_GOVERNANCE_COMMAND_REGISTRY = Object.freeze([
    ...BASE_ORGANIZATION_GOVERNANCE_COMMAND_REGISTRY,
    ...FEE_RULE_GOVERNANCE_COMMANDS,
]);
export const EFFECTIVE_ORGANIZATION_GOVERNANCE_READ_RESOURCES = Object.freeze([
    ...BASE_ORGANIZATION_GOVERNANCE_READ_RESOURCES,
    ...FEE_RULE_GOVERNANCE_READ_RESOURCES,
]);
